<template>
    <span v-if="mostrarBtnDesfazerCancelamentoDespViagem" class="ml-1">
        <span class="text-warning">
            <i
                class="fa fa-refresh fa-lg icon-button"
                title="Desfazer cancelamento despesa de viagem"
                @click.stop="confirmarDesfazerCancelamentoDespViagem()"
            ></i>
        </span>
    </span>
</template>

<script>
export default {
    props: {
        despViagem: {
            type: Object,
            default: () => ({})
        },

        contratacoesServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarDesfazerCancelamentoDespViagem() {
            this.$swal({
                title: 'Defazer Cancelamento Despesa de Viagem',
                html: `Confirma desfazer o cancelamento da despesa de viagem ${this.despViagem.nome} da contratação ${this.despViagem.codContratacao}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.desfazerCancelamentoDespViagem()
                }
            })
        },

        desfazerCancelamentoDespViagem() {
            this.$store.dispatch('addRequest')
            let despViagemCanceladaDto = {
                codContratacao: this.despViagem.codContratacao,
                tipo: this.despViagem.nome == 'CONSULTORIA' ? 0 : 1
            }
            this.contratacoesServicos
                .desfazerCancelamentoDespViagem(despViagemCanceladaDto)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterAtualizacao')
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERRO',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnDesfazerCancelamentoDespViagem() {
            return (
                this.$temAcesso('CRED-UABS-CONT-05') &&
                this.despViagem.cancelada
            )
        }
    }
}
</script>
